import axios from 'axios'
// import store from '@/store'
import base from "../common/base.js"
var ip='';
if (process.env.NODE_ENV === "development"){
// 	// 开发环境
  var appUrl = 'https://wxtest.jushoucrm.cn/';
  ip='https://wxtest.jushoucrm.cn/api/'
  // ip='http://192.168.0.126:8092/'
  //  ip='http://192.168.0.128:8092/'
  // base.setStorage('openid','oHxOe6tWjNQ7Vc2z8guPtjPrkoH0')
}else if(process.env.NODE_ENV === "production"){
	// 线上环境
  ip='/api/';
  var appUrl = window.location.origin+'/';
}
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL:ip,// 
  // 超时
  timeout: 500000
})

// request拦截器
service.interceptors.request.use(config => {
  // get请求映射params参数
if(config.method=='post'){
  if(config['url']=='/officialaccount/feedback/uploadPhoto'){
    config.headers['Content-Type'] = 'multipart/form-data'
  }else{
    config.data = {
      openid: base.getStorage('openid'),
      url:  appUrl,
      ...config.data
  }
}
}
if(config.method=='get'){
    config.params={
        openid: base.getStorage('openid'),
        url: appUrl,
        ...config.params
    }
}
  if (config.method === 'get' && config.params) {
    let url = config.url + '?';
    for (const propName of Object.keys(config.params)) {
      const value = config.params[propName];
      var part = encodeURIComponent(propName) + "=";
      if (value !== null && typeof(value) !== "undefined") {
        if (typeof value === 'object') {
          for (const key of Object.keys(value)) {
            let params = propName + '[' + key + ']';
            var subPart = encodeURIComponent(params) + "=";
            url += subPart + encodeURIComponent(value[key]) + "&";
          }
        } else {
          url += part + encodeURIComponent(value) + "&";
        }
      }
    }
    url = url.slice(0, -1);
    config.params = {};
    config.url = url;
  }
  return config
}, error => {
    Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
    // 未设置状态码则默认成功状态
    const code = res.status || 200;
    // 获取错误信息
    // const msg = errorCode[code] || res.data.msg || errorCode['default']
    if (code === 401) {
    
    } else if (code === 500) {
    
    //   return Promise.reject(new Error(msg))
    } else {
      return res.data
    }
  },
  error => {
    console.log('err' + error)
    let { message } = error;
    if (message == "Network Error") {
      message = "后端接口连接异常";
    }
    else if (message.includes("timeout")) {
      message = "系统接口请求超时";
    }
    else if (message.includes("Request failed with status code")) {
      message = "系统接口" + message.substr(message.length - 3) + "异常";
    }
    // Message({
    //   message: message,
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js